import { CourseIdEnum } from '@modules/learning/types/learning';
import { CourseId } from '@modules/learning/utils/courseUtils';
import { join } from '@modules/utilities/utils/path';

const avatarBeginnerImage = join(process.env.assetPathPrefix, 'courses', 'avatar-beginner.webp');
const avatarIntermediateImage = join(
  process.env.assetPathPrefix,
  'courses',
  'avatar-intermediate.webp',
);
const experienceBeginnerImage = join(
  process.env.assetPathPrefix,
  'courses',
  'experience-beginner.webp',
);
const experienceIntermediateImage = join(
  process.env.assetPathPrefix,
  'courses',
  'experience-intermediate.webp',
);

export interface CourseConfig {
  id: string;
  titleKey: string;
  courseId: CourseId;
  descriptionKey: string;
  imageSrc: string;
  imageAlt: string;
}

export const courseConfigs: CourseConfig[] = [
  {
    id: CourseIdEnum.AVATAR_BEGINNER,
    titleKey: 'Label.AvatarBeginner',
    courseId: 'AvatarBeginner',
    descriptionKey: 'Message.AvatarBeginnerDescription',
    imageSrc: avatarBeginnerImage,
    imageAlt: 'Avatar Beginner Course',
  },
  {
    id: CourseIdEnum.AVATAR_INTERMEDIATE,
    titleKey: 'Label.AvatarIntermediate',
    courseId: 'AvatarIntermediate',
    descriptionKey: 'Message.AvatarIntermediateDescription',
    imageSrc: avatarIntermediateImage,
    imageAlt: 'Avatar Intermediate Course',
  },
  {
    id: CourseIdEnum.EXPERIENCE_BEGINNER,
    titleKey: 'Label.ExperienceBeginner',
    courseId: 'ExperienceBeginner',
    descriptionKey: 'Message.ExperienceBeginnerDescription',
    imageSrc: experienceBeginnerImage,
    imageAlt: 'Experience Beginner Course',
  },
  {
    id: CourseIdEnum.EXPERIENCE_INTERMEDIATE,
    titleKey: 'Label.ExperienceIntermediate',
    courseId: 'ExperienceIntermediate',
    descriptionKey: 'Message.ExperienceIntermediateDescription',
    imageSrc: experienceIntermediateImage,
    imageAlt: 'Experience Intermediate Course',
  },
];

export const courseCourseIdMap: Record<string, CourseId> = {
  [CourseIdEnum.AVATAR_BEGINNER]: 'AvatarBeginner',
  [CourseIdEnum.AVATAR_INTERMEDIATE]: 'AvatarIntermediate',
  [CourseIdEnum.EXPERIENCE_BEGINNER]: 'ExperienceBeginner',
  [CourseIdEnum.EXPERIENCE_INTERMEDIATE]: 'ExperienceIntermediate',
  [CourseIdEnum.EXPERIENCE_ADVANCED]: 'ExperienceIntermediate',
};
